"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const styled_1 = __importDefault(require("@emotion/styled"));
const RootButton_1 = __importDefault(require("./RootButton"));
const BaseButton = (0, styled_1.default)(RootButton_1.default, {
    shouldForwardProp: (prop) => (0, is_prop_valid_1.default)(prop) && prop !== 'color'
})(({ theme, rounded = false, fullWidth = false, size = 'medium', color = 'primary', variant = 'contained' }) => ({
    'cursor': 'pointer',
    'borderRadius': rounded ? '72px' : '6px',
    'borderWidth': size === 'small' ? '1px' : '2px',
    'fontSize': theme.typography.fontSize.large,
    'fontWeight': theme.typography.fontWeightMedium,
    'minWidth': 'fit-content',
    '&:hover, &:active': {
        backgroundColor: 'transparent'
    },
    ...(size === 'small' && {
        fontSize: theme.typography.fontSize.medium,
        padding: '7px 13px'
    }),
    ...(fullWidth && {
        width: '100%'
    }),
    ...(variant === 'text' && {
        fontSize: theme.typography.fontSize.medium,
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        ...(color === 'primary' && {
            'color': theme.palette.colors.orangeRed,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.cinnabar,
                color: theme.palette.colors.white
            },
            '&:disabled': {
                color: theme.palette.colors.melon,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'secondary' && {
            'color': theme.palette.colors.midnightBlue,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.antiFlash
            },
            '&:disabled': {
                color: theme.palette.colors.lightPeriwinkle,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'midnight' && {
            'color': theme.palette.colors.midnightBlue,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.midnightBlue,
                color: theme.palette.colors.white
            },
            '&:disabled': {
                color: theme.palette.colors.linkWater1,
                cursor: 'not-allowed'
            }
        })
    }),
    ...(variant === 'contained' && {
        ...(color === 'primary' && {
            'backgroundColor': theme.palette.colors.orangeRed,
            'borderColor': theme.palette.colors.orangeRed,
            'color': theme.palette.colors.white,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.cinnabar
            },
            '&:disabled': {
                backgroundColor: theme.palette.colors.melon,
                borderColor: theme.palette.colors.melon,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'secondary' && {
            'backgroundColor': theme.palette.colors.antiFlash,
            'borderColor': theme.palette.colors.antiFlash,
            'color': theme.palette.colors.midnightBlue,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.azureish,
                borderColor: theme.palette.colors.azureish
            },
            '&:disabled': {
                backgroundColor: theme.palette.colors.white,
                borderColor: theme.palette.colors.lightPeriwinkle,
                color: theme.palette.colors.lightPeriwinkle,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'midnight' && {
            'backgroundColor': theme.palette.colors.midnightBlue,
            'borderColor': theme.palette.colors.midnightBlue,
            'color': theme.palette.colors.white,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.rhino,
                borderColor: theme.palette.colors.rhino
            },
            '&:disabled': {
                backgroundColor: theme.palette.colors.linkWater1,
                borderColor: theme.palette.colors.linkWater1,
                cursor: 'not-allowed'
            }
        })
    }),
    ...(variant === 'outlined' && {
        backgroundColor: theme.palette.colors.white,
        ...(color === 'primary' && {
            'borderColor': theme.palette.colors.orangeRed,
            'color': theme.palette.colors.orangeRed,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.cinnabar,
                color: theme.palette.colors.white
            },
            '&:disabled': {
                borderColor: theme.palette.colors.melon,
                color: theme.palette.colors.melon,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'secondary' && {
            'borderColor': theme.palette.colors.midnightBlue,
            'color': theme.palette.colors.midnightBlue,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.antiFlash,
                borderColor: theme.palette.colors.pastelBlue
            },
            '&:disabled': {
                color: theme.palette.colors.lightPeriwinkle,
                borderColor: theme.palette.colors.lightPeriwinkle,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'midnight' && {
            'borderColor': theme.palette.colors.midnightBlue,
            'color': theme.palette.colors.midnightBlue,
            '&:hover, &:active': {
                backgroundColor: theme.palette.colors.midnightBlue,
                color: theme.palette.colors.white
            },
            '&:disabled': {
                color: theme.palette.colors.lightPeriwinkle,
                borderColor: theme.palette.colors.lightPeriwinkle,
                cursor: 'not-allowed'
            }
        })
    }),
    ...(variant === 'link' && {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        textDecoration: 'underline',
        ...(color === 'primary' && {
            'color': theme.palette.colors.orangeRed,
            '&:hover, &:active': {
                color: theme.palette.colors.cinnabar,
                textDecoration: 'none'
            },
            '&:disabled': {
                color: theme.palette.colors.melon,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'secondary' && {
            'color': theme.palette.colors.midnightBlue,
            '&:hover, &:active': {
                color: theme.palette.colors.antiFlash,
                textDecoration: 'none'
            },
            '&:disabled': {
                color: theme.palette.colors.lightPeriwinkle,
                cursor: 'not-allowed'
            }
        }),
        ...(color === 'midnight' && {
            'color': theme.palette.colors.midnightBlue,
            '&:hover, &:active': {
                color: theme.palette.colors.rhino,
                textDecoration: 'none'
            },
            '&:disabled': {
                color: theme.palette.colors.linkWater1,
                cursor: 'not-allowed'
            }
        })
    })
}));
exports.default = BaseButton;
//# sourceMappingURL=BaseButton.js.map